export const INTEGRATION_CATEGORIES: Record<string, string> = {
  ecommerce: 'E-Commerce',
  payments: 'Payments',
  advertising: 'Advertising & Feeds',
  messaging: 'Messaging & Chat',
  shipping: 'Shipping & Logistics',
  productivity: 'Productivity',
  automation: 'Automation & API',
};

export interface IntegrationFieldDef {
  key: string;
  label: string;
  type: 'text' | 'password' | 'boolean' | 'select';
  placeholder?: string;
  default?: boolean | string;
  options?: string[];
}

export interface IntegrationCatalogItem {
  key: string;
  label: string;
  category: string;
  categoryLabel?: string;
  description: string;
  icon: string;
  phase: number;
  allowed: boolean;
  featured?: boolean;
  adminNotes?: string;
  supportsSync?: boolean;
  [key: string]: unknown;
}

export interface TenantIntegrationItem {
  provider: string;
  label: string;
  category: string;
  categoryLabel?: string;
  description: string;
  icon?: string;
  fields: IntegrationFieldDef[];
  supportsSync?: boolean;
  featured?: boolean;
  enabled: boolean;
  config: Record<string, unknown>;
  lastSyncAt?: string;
  lastSyncStatus?: string;
}
